<template>
  <v-layout>
    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="historial"
        :loading="loader"
        loading-text="Listando Datos..."
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">Historial de Reenvios Encuesta SISA</h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md3 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaInicio"
                  type="date"
                  hide-details
                  label="Inicio"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaFin"
                  type="date"
                  hide-details
                  label="Fin"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn color="blue" dark @click="listarHistorial" block>
                  Listar
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn
                  color="green"
                  :block="$vuetify.breakpoint.smAndDown"
                  dark
                  @click="formatReporte"
                >
                  <v-icon class="ml-2">fas fa-file-excel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.fecha`]="{ item }">
          {{ formatDate(item.fecha, true) }}
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment, { isDate } from "moment";
import XLSX from "xlsx";

export default {
  name: "HistorialReenvioEncuestas",
  data() {
    return {
      text: "Historial Reenvio Encuestas SISA",
      search: "",
      loader: false,
      dialog: false,
      selectedHistorial: null,
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      historial: [],
      headers: [
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          sortable: true,
          align: "center",
        },
        {
          text: "Usuario",
          value: "usuario",
          sortable: true,
          align: "center",
        },
        {
          text: "Fecha Reenvio",
          value: "fecha",
          sortable: true,
          align: "center",
          width: 250,
        },
      ],
    };
  },
  created() {
    const today = new Date();
    const firstDayInMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.fechaInicio = firstDayInMonth.toISOString().substring(0, 10);
    this.inicioReporte = this.fechaInicio;

    this.listarHistorial();
  },
  computed: {},
  methods: {
    limpiar() {
      this.selectedHistorial = null;
      this.dialog = false;
    },
    ExportarExcel(listado) {
      let data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();
      const filename = `Historial Reenvio Encuestas ${this.fechaInicio.toString(
        "yyyy-MM-dd"
      )} a ${this.fechaFin.toString("yyyy-MM-dd")}`;

      data["!cols"] = [
        { wch: 15 },
        { wch: 27 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
      ];
      XLSX.utils.book_append_sheet(workbook, data, "Historial");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    formatReporte() {
      const listadoHistorial = this.historial.map((data) => {
        const fechaHora = this.formatDate(data.fecha, true);
        const fechaHoraSplitted = fechaHora.split(" ");

        const historial = {
          NumeroAsistencia: data.numeroAsistencia,
          Usuario: data.usuario,
          Fecha: fechaHoraSplitted[0],
          Hora: fechaHoraSplitted[1],
        };

        delete historial.historialEnvioEncuestasId;
        delete historial.usuarioId;

        return historial;
      });

      this.ExportarExcel(listadoHistorial);
    },
    listarHistorial() {
      this.loader = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `Sisa/HistorialEncuesta?fechaInicio=${this.fechaInicio}&fechaFin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => {
          this.historial = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    formatDate(fecha, isDateTime = false) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      return isDateTime
        ? moment(fecha).format("YYYY-MM-DD HH:mm:ss")
        : moment(fecha).format("YYYY-MM-DD");
    },
  },
};
</script>